import {Phone} from 'lucide-react';
import {useIntl} from 'react-intl';
import {groupCallMessages as m} from '../messages';
import type {RoomCallEntry} from '../services/roomCallEntry';
import {groupCallService} from '../services/groupCallService';
import {openRoomCallLobby} from './groupCallActions';

// Same shape as the design's in-header call action (Join): 32px, 10px radius, brand fill.
const pillClass = 'phq-call-ui mx-2 inline-flex h-8 shrink-0 items-center gap-2 whitespace-nowrap rounded-control px-3.5 text-callout font-semibold';

export const GroupRoomCallButtons = ({entry, roomId}: {entry: RoomCallEntry; roomId: string | null | undefined}) => {
    const intl = useIntl();
    if (!roomId) {
        return null;
    }
    switch (entry.kind) {
        case 'group_start': {
            const busyText = intl.formatMessage(m.callBusy);
            const startLabel = intl.formatMessage(m.startCall);
            return (
                <button
                    type="button"
                    data-testid="group-call-start-audio"
                    aria-label={entry.busy ? `${startLabel}, ${busyText}` : startLabel}
                    aria-disabled={entry.busy || undefined}
                    data-tooltip-left={entry.busy ? busyText : startLabel}
                    className={`mr-1 ${entry.busy ? 'cursor-not-allowed opacity-50' : ''}`}
                    onClick={() => openRoomCallLobby(roomId, 'audio')}
                >
                    <Phone size={32} className="button p-1.5"/>
                </button>
            );
        }
        case 'group_join':
        case 'group_full':
            return null;
        case 'group_in_call':
            return (
                <button
                    type="button"
                    data-testid="group-call-return"
                    className={`${pillClass} bg-brand text-white hover:bg-brand-hover`}
                    onClick={() => groupCallService.setMinimized(false)}
                >
                    <Phone size={18} aria-hidden="true" className="!p-0 !text-current"/>
                    {intl.formatMessage(m.returnToCall)}
                </button>
            );
        case 'group_unavailable':
            return (
                <button
                    type="button"
                    disabled
                    data-testid="group-call-unavailable"
                    aria-label={intl.formatMessage(entry.reason === 'not_owner' ? m.notOwner : m.noSession)}
                    data-tooltip-left={intl.formatMessage(entry.reason === 'not_owner' ? m.notOwner : m.noSession)}
                    className="mr-1 cursor-not-allowed opacity-40"
                >
                    <Phone size={32} className="button p-1.5"/>
                </button>
            );
        default:
            return null;
    }
};
